import RedirectBackButton from "components/RedirectBackButton";
import { FORM_ERROR } from "final-form";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import useTrashablePromises from "hooks/useTrashablePromises";
import { FormattedMessage as T, useIntl } from "react-intl";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import {
  CertificateTemplateRequest,
  SaveResponse,
} from "services/KnowfullyAdminClient";
import translateError from "utils/translateError";
import CertificateTemplateForm from "./CertificateTemplateForm";

const CertificateTemplateCreateForm = () => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const {
    certificateService,
    certificateTemplatesUrl,
    certificateTemplateDetailsUrl,
  } = useGlobalContext();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  useTitle(t({ id: "certificateTemplateFormCreateButton" }));

  const onCancel = () => {
    navigate(certificateTemplatesUrl());
  };

  const onSubmit = async (values: CertificateTemplateRequest) => {
    try {
      const response: SaveResponse = await registerPromise(
        certificateService.saveCertificateTemplate(values)
      );
      queryClient.invalidateQueries("certificateTemplates");
      navigate(certificateTemplateDetailsUrl(response.id));
      return response;
    } catch (err: any) {
      return { [FORM_ERROR]: translateError(err, t) };
    }
  };

  return (
    <>
      <RedirectBackButton
        redirectRoute={certificateTemplatesUrl()}
        labelKey="backToListButtonLabel"
      />
      <h2>
        <T id="certificateTemplateFormCreateTitle" />
      </h2>
      <CertificateTemplateForm
        onSubmit={onSubmit}
        submitLabel={t({ id: "certificateTemplateFormCreateButton" })}
        onCancel={onCancel}
      />
    </>
  );
};

export default CertificateTemplateCreateForm;
